import { IntersectionType } from '@nestjs/swagger';
import { Exclude } from 'class-transformer';
import { BuilderInterface } from '../../builder/interfaces/builder.interface';
import { ArchivableEntityDto } from '../../common/dto/archivable-entity.dto';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { JobInterface } from '../../job/interfaces/job.interface';
import { SubdivisionInterface } from '../../subdivision/interfaces/subdivision.interface';
import { ScheduledEmailsWeeklyBuilderSupervisorInterface } from '../interfaces/scheduled-emails-weekly-builder-supervisor.interface';

@Exclude()
export class ScheduledEmailsWeeklyBuilderSupervisorDto
  extends IntersectionType(CommonEntityDto, ArchivableEntityDto)
  implements ScheduledEmailsWeeklyBuilderSupervisorInterface
{
  supervisorEmail!: string;
  subdivisionBuilderSupervisorEmail!: string;
  jobId!: string;
  jobLot!: string;
  jobBlock!: string;
  builderId!: string;
  builderName!: string;
  modelId!: string;
  modelName!: string;
  subdivisionId!: string;
  subdivisionName!: string;
  orderNumber!: string;
  orderDate!: string;
  dateExpected!: string;
  address1!: string;
  address2!: string;
  city!: string;
  state!: string;
  zip!: string;
  job?: JobInterface | undefined;
  subdivision?: SubdivisionInterface | undefined;
  builder?: BuilderInterface | undefined;
}
